import { FC } from "react";
import { Grid, Card, Icon, SemanticICONS, Tab } from "semantic-ui-react";
import { ResourcesTabProps } from "./types";

const MarketplaceAppDetailResourcesTab: FC<ResourcesTabProps> = ({
  resources,
}) => (
  <Tab.Pane>
    <div className="marketplace-app-detail-resource">
      <Grid stackable doubling columns={3}>
        {resources.map((resource, index) => (
          <Grid.Column key={index}>
            <Card className="ui card height-100p" fluid>
              <Card.Header className="resource-card-title padding-left-10">
                <a
                  href={resource.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex"
                >
                  <Icon
                    name={resource.icon as SemanticICONS}
                    className="margin-right-half"
                  />
                  {resource.title}
                </a>
              </Card.Header>
              <Card.Content className="resource-card-content">
                <Card.Description className="resource-card-description padding-top-10 padding-bottom-10">
                  {resource.description}
                </Card.Description>
              </Card.Content>
            </Card>
          </Grid.Column>
        ))}
      </Grid>
    </div>
  </Tab.Pane>
);

export default MarketplaceAppDetailResourcesTab;
